import * as React from 'react'

import { Checkbox } from 'main/ui'
import { UnreachableCaseError } from 'main/util/ts'
import { MapState } from '../types'
import { OnMoveContainer, OnRequestButton, OnRequestContainer } from './BoundsControl.styles'
import { SetBounds, SetBoundsType } from './types'

interface IProps {
  mapState: MapState | null
  setBounds: SetBounds
}

export default function BoundsControl(props: IProps) {
  const { mapState, setBounds } = props

  switch (setBounds.__typename) {
    case SetBoundsType.OnMove:
      return (
        <OnMoveContainer>
          <Checkbox
            label={setBounds.label}
            checked={setBounds.enabled}
            onChange={setBounds.onChangeEnabled}
          />
        </OnMoveContainer>
      )
    case SetBoundsType.OnRequest:
      return (
        <OnRequestContainer>
          <OnRequestButton
            onClick={() => {
              if (mapState) {
                setBounds.onChangeBounds(mapState.bounds)
              }
            }}
          >
            {setBounds.label}
          </OnRequestButton>
        </OnRequestContainer>
      )
    default:
      throw new UnreachableCaseError(setBounds)
  }
}
